<script setup lang="ts">
import {IonButton, IonCol, IonGrid, IonRow} from "@ionic/vue";
import InputTime from '@/components/InputTime.vue'
import {PropType, ref, watch} from "vue";
import Modal from "@/components/Modal.vue";
import datetime from "@/helper/datetime/datetime";
import {kapitelTimeString} from "@/graphql/kapitelTypes";
import {BookingInput} from "@/helper/registerBooking";

const props = defineProps({
    booking: {
        type: Object as PropType<BookingInput>,
        required: true
    },
    modelValue: Boolean
});

const emit = defineEmits(["update:modelValue", "update:bookingTimes"]);
const isOpen = ref(false);

const newBegin = ref<kapitelTimeString | undefined>(undefined);
const newUntil = ref<kapitelTimeString | undefined>(undefined);

watch(
    () => props.modelValue,
    (value) => {
        isOpen.value = value;
    },
);
watch(
    () => isOpen.value,
    (value) => {
        emit("update:modelValue", value);
    },
);

watch(
    () => props.booking,
    (booking) => {
        if(booking){
            newBegin.value = datetime.convertDateTime2Time(booking.begin);
            newUntil.value = datetime.convertDateTime2Time(booking.until);
        }
    },
);

const submit = () => {

    if (!newBegin.value || !newUntil.value) {
        return;
    }

    const newBooking: BookingInput = {
        date: datetime.convertDateTime2Date(props.booking.begin),
        begin: datetime.convertDateAndTime2DateTime(
            datetime.convertDateTime2Date(props.booking.begin),
            newBegin.value
        ),
        until: datetime.convertDateAndTime2DateTime(
            datetime.convertDateTime2Date(props.booking.until),
            newUntil.value
        ),
        jobsite: props.booking.jobsite,
        qualification: props.booking.qualification,
        shiftTimeSource: undefined,
    }
    emit("update:bookingTimes", newBooking, props.booking);

    isOpen.value = false;

};
</script>

<template>
    <Modal v-model="isOpen" title="Einsatz ändern">
        <br />
        <br />
        <ion-grid>
            <ion-row>
                <ion-col>
                    <InputTime
                        label="Anfang"
                        v-model="newBegin"
                        :nullable="false"
                    />
                </ion-col>
                <ion-col>
                    <InputTime
                        label="Ende"
                        v-model="newUntil"
                        :nullable="false"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-button @click="submit" expand="block" color="secondary">
            Zeiten übernehmen
        </ion-button>
    </Modal>
</template>
